import type { ReactNode } from "react";

export enum ContrastModes {
	DARK = "dark",
	LIGHT = "light",
	SYSTEM = "system",
}

export interface SettingsProviderProps {
	children: ReactNode;
	/**
	 * Class toggled on `document.documentElement` when the theme is dark.
	 * @default "dark-mode"
	 */
	darkModeClass?: string;
	/**
	 * Used when localStorage has no saved preference.
	 * @default ContrastModes.SYSTEM
	 */
	defaultContrastMode?: ContrastModes;
	/**
	 * localStorage key — must stay in sync with the FOUC script in `index.html`.
	 * @default "ui-theme"
	 */
	storageKey?: string;
}
